<template>
  <div class="Login">
    <div class="nav">
      <div class="left">
        <img src="../../assets/icons/logo_g.png" alt="" draggable="false">
        <p>Gbozo App</p>
      </div>
      <div class="right">
        <p>Contact WeChat ID: elomkovsky</p>
      </div>
    </div>

    <div class="title">Dashboard Login</div>
    <div class="box">
      <div>
        <form>
          <ul>
            <li>
              <label>
                Email (邮箱)
                <input type="email" v-model="email"
                       placeholder="Enter your email"
                       name="email"
                       autocomplete="current-email">
              </label>
              <div class="warn">
                <p v-show="!email_check">Email is required (邮箱必填).</p>
              </div>
            </li>
            <li>
              <label>
                <span>Password (密码)</span>
                <input type="password" v-model="password" placeholder="Enter your password" name="password"
                       autocomplete="current-password">
              </label>
              <div class="warn">
                <p v-show="!password_check">Password is required (密码必填).</p>
              </div>
            </li>
          </ul>
          <el-button type="primary" round @click.prevent="onLoginSubmit" :loading="login_loading">Login</el-button>
        </form>
        <el-alert v-if="alert_show" :title="alert_text" :type="alert_type" show-icon></el-alert>

      </div>
    </div>

  </div>
</template>

<script>
  import {loginSubmit} from "@/utils/api";
  export default {
    data: () => {
      return {
        login_loading: false,
        alert_show: false,
        alert_text: '',
        alert_type: 'error',
        email: '',
        password: '',
        email_check: true,
        password_check: true,
      }
    },
    beforeCreate() {
      localStorage.removeItem('token');
      this.$store.commit('delToken');
    },
    watch: {
      // email(n,o){
      //   console.log(n,o)
      // }
    },
    methods: {
      onLoginSubmit() {
        this.alert_show = false;
        this.email_check = !!this.email;
        this.password_check = !!this.password;
        if (this.email !== '' && this.password !== '') {
          this.login_loading = true;
          loginSubmit(this.email, this.password).then(data => {
            this.login_loading = false;
            this.alert_show = true;
            this.alert_type = data.errcode === 0?'success':'error';
            this.alert_text = data.errmsg;
            if (data.errcode === 0) {
              let token = data.token;
              localStorage.setItem('token', token);
              this.$store.commit('setToken', token);
              setTimeout(()=>{
                this.$router.replace('/');
                this.$showLoading('Loading')
              },1000)
            }
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "_Login.scss";

</style>